import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo with Link */}
        <div className="footer-logo">
          <a href="/" className="logo-link">
            <img src="/images/wf_logo3.png" alt="Wholeness Forward Logo" />
          </a>
        </div>

        {/* Social Media Links */}
        <div className="footer-social">
          {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a> */}
          <a href="https://x.com/WholenesForward" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://www.instagram.com/wholeness_forward/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          {/* <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a> */}
        </div>

        {/* Basic Information */}
        <div className="footer-info">
          <p>&copy; 2025 Wholeness Forward. All rights reserved.</p>
          <p>Contact us: <a href="mailto:admin@wholenessforward.com">admin@wholenessforward.com</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
